import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';
import { showToast } from '@doltech/ui/lib/figma/Toast';
import { stringifyEditorFields } from '@doltech/utils/lib/object';
import { noop } from 'lodash';

const transformDetail = (data) => {
  (data as any).topicId = data?.topic?.id;
  return data;
};

const processUpdateOrPublishDailyFacts = async ({ payload, onSuccess = noop, apiFn }) => {
  try {
    stringifyEditorFields(payload, []);
    await apiFn({
      id: payload?.id,
      payload,
    });
    onSuccess();
  } catch (ex) {
    showToast({
      icon: 'error',
      title: 'Oops, something went wrong',
      subTitle: ex?.response?.data?.code || ex.message,
    });
  }
};

export const getDailyFacts = async (query: any) => {
  const { data } = await apis.onlineTest.get(apiUrls.onlineTest.DAILY_LEARNING_FACT, query);
  return data;
};



export const createDailyFacts = async ({ payload }) => {
  const res = await apis.onlineTest.post(apiUrls.onlineTest.DAILY_LEARNING_FACT, payload);
  return res.data;
};

export const updateDailyFacts = async ({ id, payload }) => {
  const { data } = await apis.onlineTest.put(
    apiUrls.onlineTest.DAILY_LEARNING_FACT_DETAIL,
    payload,
    {
      params: { id },
    },
  );
  return transformDetail(data);
};

export const deleteDailyFacts = async (id) => {
  const { data } = await apis.onlineTest.delete(apiUrls.onlineTest.DAILY_LEARNING_FACT_DETAIL, {
    id,
  });
  return data;
};

export const activeDailyFacts = async ({ id, payload }) => {
  const { data } = await apis.onlineTest.put(
    apiUrls.onlineTest.ACTIVE_DAILY_LEARNING_FACT_DETAIL,
    payload,
    {
      params: { id },
    },
  );
  return data;
};

export const createProcessDailyFacts = async ({ payload, onSuccess = noop }) => {
  return processUpdateOrPublishDailyFacts({
    payload,
    onSuccess,
    apiFn: createDailyFacts,
  });
};

export const saveDailyFacts = async ({ payload, onSuccess = noop }) => {
  return processUpdateOrPublishDailyFacts({
    payload,
    onSuccess,
    apiFn: updateDailyFacts,
  });
};


